(function ($) {
  // noConflict モード: ここから下では $ で jQuery を使用
  class Top {
    constructor(el, opt) {
      this.el = el;
      if ($("." + this.el).length > 0) {
        this.init();
      }
    }
  
    init() {
      this.event();
    }
  
    event() {
      this.initPhotoStripSwiper();
      this.initPeopleSwiper();
      this.initEnvironmentImg();
    }
  
    /**
     * FUTURE 直下フォトストリップ（s-slider-img01〜08）
     */
    initPhotoStripSwiper() {
      const root = document.querySelector(".p-top .js-topPhotoStripSwiper");
      if (!root || typeof Swiper === "undefined") return;
  
      new Swiper(root, {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 16,
        allowTouchMove: false,
        speed: 6000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
      });
    }
  
    /**
     * PEOPLE: SP（767px以下）は2件以上で Swiper＋ナビ。PCは4件以上。
     * 1件・または PC で2〜3件は静的表示・ナビ非表示。
     */
    initPeopleSwiper() {
      const root = document.querySelector(".p-top .js-topPeopleSwiper");
      const wrap = document.querySelector(".p-top .s-people__slider-wrap");
      if (!root || !wrap || typeof Swiper === "undefined") return;
  
      const peopleCount = parseInt(wrap.getAttribute("data-people-count") || "0", 10);
      if (peopleCount === 0) return;
  
      const nextEl = document.querySelector(".p-top .s-people__next");
      const prevEl = document.querySelector(".p-top .s-people__prev");
      const paginationEl = document.querySelector(".p-top .s-people__pagination");
      if (!nextEl || !prevEl || !paginationEl) return;
  
      const mqSp = window.matchMedia("(max-width: 767px)");
      let swiperInstance = null;
  
      const shouldUseSwiper = () => {
        if (mqSp.matches) {
          return peopleCount >= 2;
        }
        return peopleCount >= 4;
      };
  
      const apply = () => {
        if (!shouldUseSwiper()) {
          if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
          }
          wrap.classList.add("is-people-static");
          return;
        }
  
        wrap.classList.remove("is-people-static");
        if (swiperInstance) return;
  
        swiperInstance = new Swiper(root, {
          slidesPerView: "auto",
          spaceBetween: 16,
          watchOverflow: false,
          navigation: {
            nextEl,
            prevEl,
          },
          pagination: {
            el: paginationEl,
            type: "progressbar",
          },
          breakpoints: {
            768: {
              slidesPerView: "auto",
              spaceBetween: 18,
            },
            1024: {
              slidesPerView: "auto",
              spaceBetween: 20,
            },
          },
        });
      };
  
      apply();
      mqSp.addEventListener("change", apply);
    }
  
    /**
     * ENVIRONMENT（s-environment）リストホバー／フォーカスで右カラム画像をフェード切り替え
     */
    initEnvironmentImg() {
      const section = document.querySelector(".p-top .s-environment");
      if (!section) return;
  
      const inner = section.querySelector(".s-environment__inner");
      const layers = section.querySelectorAll(".js-environmentImgLayer");
      const items = section.querySelectorAll(".s-environment__item[data-environment-src]");
      if (!inner || layers.length !== 2 || items.length === 0) return;
  
      const defaultSrc =
        layers[0].getAttribute("data-default-src") ||
        layers[0].getAttribute("src") ||
        "";
  
      let visibleLayer = 0;
      let swapToken = 0;
  
      const showSrc = (src) => {
        if (!src) return;
  
        const outgoing = layers[visibleLayer];
        if (outgoing.src === src) return;
  
        const incoming = layers[1 - visibleLayer];
        const myToken = ++swapToken;
  
        const reveal = () => {
          if (myToken !== swapToken) return;
          incoming.classList.add("is-visible");
          outgoing.classList.remove("is-visible");
          visibleLayer = 1 - visibleLayer;
        };
  
        incoming.src = src;
  
        if (incoming.complete) {
          reveal();
          return;
        }
  
        incoming.addEventListener(
          "load",
          () => {
            if (myToken !== swapToken) return;
            reveal();
          },
          { once: true },
        );
      };
  
      items.forEach((item) => {
        const src = item.getAttribute("data-environment-src");
        const link = item.querySelector(".s-environment__item-link");
        if (!link || !src) return;
  
        link.addEventListener("mouseenter", () => showSrc(src));
        link.addEventListener("focusin", () => showSrc(src));
      });
  
      inner.addEventListener("mouseleave", () => showSrc(defaultSrc));
  
      inner.addEventListener("focusout", (e) => {
        const next = e.relatedTarget;
        if (!next || !inner.contains(next)) {
          showSrc(defaultSrc);
          return;
        }
        const onEnvLink = [...items].some((el) => el.contains(next));
        if (!onEnvLink) showSrc(defaultSrc);
      });
    }
  }
  
  class Accordion {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $('.' + this.el).click(function() {
         $(this).next().slideToggle(Number($('html').data('transition')));
         $(this).toggleClass('is-active');
      })
    }
  }
    // 参考サイト
  // https://hacknote.jp/archives/15289/
  
  let cookie = {
  	/**
  	 * 取得
  	 * @param {string} cookieName 取得するCookieの名前
  	 */
  	get : function(cookieName) {
  		if (!navigator.cookieEnabled) return false;
  
  		var getCookieAllData  = document.cookie,
  		    getCookieAllDatas = getCookieAllData.split(';'),
  		    getCookieDatas    = {},
  		    cookieKeyValue    = [],
  		    cookieKey         = '',
  		    cookieValue       = '';
  
  		var hashLength = function(arr) {
  			var result = 0, key = false;
  
  			if (typeof arr !== 'object') return false;
  
  			for (key in arr) result++;
  
  			return result;
  		};
  
  		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
  			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
  				cookieKeyValue = getCookieAllDatas[i].split('=');
  				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
  				cookieValue    = '';
  
  				if (cookieKeyValue[1]) {
  					cookieValue = decodeURIComponent(cookieKeyValue[1]);
  				}
  
  				getCookieDatas[cookieKey] = cookieValue;
  			}
  		}
  
  		if (hashLength(getCookieDatas) > 0) {
  			if (cookieName && cookieName in getCookieDatas) {
  				return getCookieDatas[cookieName];
  			} else {
  				return getCookieDatas;
  			}
  		} else {
  			return '';
  		}
  	},
  
  	/**
  	 * 設定
  	 * @param {string} cookieName 設定するCookieの名前
  	 * @param {string} value 設定する値
  	 * @param {string} domain 有効ドメイン
  	 * @param {string} path 有効パス
  	 * @param {string} expires 有効期限
  	 * @param {boolean} secure セキュアとするか
  	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
  	 */
  	set : function(cookieName, value, domain, path, expires, secure) {
  		if (!navigator.cookieEnabled || !cookieName || !value) return false;
  
  		var date, dt, ts, ts_after;
  
  		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';
  
  		if (domain) setCookieData += 'domain=' + domain + ';';
  
  		if (path) setCookieData += 'path=' + path + ';';
  
  		if (expires) {
        dt = new Date();
        ts = dt.getTime();
  
        // 1時間後
        ts_after = ts + (1000 * 60 * 60 * expires);
  
        date = new Date(ts_after);
  			setCookieData += 'expires=' + date.toGMTString() + ';';
  		}
  
  		if (secure && secure === true && location.protocol.match(/https/)) {
  			setCookieData += 'secure';
  		}
  
  		document.cookie = setCookieData;
  
  		return true;
  	},
  
  	/**
  	 * 削除
  	 * @param {string} cookieName 削除するCookieの名前
  	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
  	 */
  	del : function(cookieName) {
  		if (!navigator.cookieEnabled || !cookieName) return false;
  
  		var getCookieDatas = this.get();
  
  		if (getCookieDatas[cookieName]) {
  			var setCookieData = cookieName + '=;',
  			    date          = new Date(0);
  
  			setCookieData += 'expires=' + date.toGMTString() + '';
  
  			document.cookie = setCookieData;
  
  			return true;
  		}
  
  		return false;
  	}
  };
    class Editor {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      //------- サイドナビ アンカー ---------
      let options = {
        threshold: [0],
        rootMargin: '-49.9%',
      }
      const observerEnter = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio > 0){
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).siblings().removeClass('is-active')
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).addClass('is-active')
          } else {
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).removeClass('is-active')
          }
        })
      }, options)
  
      const anchorEl = document.querySelectorAll('[id*="anchor"]')
      anchorEl.forEach((e)=>{
        observerEnter.observe(e)
      })
  
      
      $('[id*="anchor"]').each(function() {
        let text = $(this).find('.anchorTitle').text();
        let id = $(this).attr('id');
        if(text) {
          let newElement = $(`<a href="#${id}" class="c-transition"><hr class="c-transition">${text}</a>`);
          $('.js-sideNav').append(newElement);
        }
      })
  
      $(".js-sideNav a").click(function() {
        setTimeout(() => {
          $(this).siblings().removeClass('is-active')
          $(this).addClass('is-active')
        }, 600)
      })
  
  
      //------- 〆サイドナビ アンカー ---------
  
      //------- 画像のheught,widthをrem化 ---------
      $('.text-editor img').each(function(index, el) {
        let width = $(el).attr('width')
        // $(el).attr('width')
        $(el).css({'width': `${width * 0.1 + 'rem'}`, 'height': `auto`})
      })
      //------- 画像のheught,widthをrem化 〆 ---------
  
      //------- アコーディオン ---------
      $('.js-editor-accordion .inner').css({'display': 'none'})
  
      $('.js-editor-accordion .trigger').on('click', function() {
        $(this).find('.trigger-icon').toggleClass('is-active')
        $(this).next().slideToggle(Number($('html').data('transition')))
      })
      //------- アコーディオン 〆 ---------
  
      //------- タブ切り替え ---------
      if($(window).innerWidth() >= '769') {
  
        //------- PCの場合 ---------
        $('.js-tab .inner > div > div:nth-of-type(n + 2)').css({'display': 'none'})
        $('.js-tab .trigger .elementor-element:nth-of-type(1)').addClass('is-active')
    
        $('.js-tab .trigger .elementor-element').on('click', function() {
          if ($(this).closest('.js-editor-accordion').length) return
          $(this).siblings().removeClass('is-active')
          $(this).addClass('is-active')
          $(this).closest('.js-tab').find('.inner-child').css({'display': 'none'})
          $(this).closest('.js-tab').find('.inner-child').eq($(this).index()).fadeIn(Number($('html').data('transition')))
        })
        //------- PCの場合 〆 ---------
  
      } else {
  
        //------- SPの場合 ---------
        $('.js-tab').each(function() {
          const _el = $(this)
          const trigger_child = _el.find('.trigger-child')
          _el.find('.inner-child').each(function(index) {
            $(this).before(trigger_child[index])
          })
        })
  
        $('<span></span>').appendTo('.trigger-child > div')
  
        $('.inner-child').css({'display': 'none'})
        $('.trigger-child').click(function() {
          $(this).find('span').toggleClass('is-active')
          $(this).next().slideToggle(Number($('html').data('transition')))
        })
        //------- SPの場合 〆 ---------
        
      }
      //------- タブ切り替え 〆 ---------
    }
  }
    class FormConvert {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      //全角から半角
      function replaceZtoH(str){
        str = str.replace(/[！-～]/g, function(s){
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
        str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
        return str;
      }
      const el = document.querySelector('.js-convert');
      el.addEventListener('blur', () => {
        const br = el.value;
        const ar = replaceZtoH(br);
        el.value = ar;
      });
    }
  }
  
    document.querySelectorAll('.js-hamburger-trigger').forEach((el) => {
    el.addEventListener('click', () => {
      document.body.classList.toggle('is-open');
    });
  });
  
  document.querySelectorAll('.js-hamburger-menu-close').forEach((el) => {
    el.addEventListener('click', () => {
      document.body.classList.remove('is-open');
    });
  });
  
    // ------------------------------------------
  // imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
  // 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
  // ------------------------------------------
  class ImgParallax {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      let cls = this.el;
      let para_ele = document.querySelectorAll("." + this.el);
      para_ele.forEach((ele, index)=> {
        let property,scrub;
  
        $(ele).css({
          'object-fit':'cover',
          'object-position':'50% 0%',
          'width':'100%',
          'height':'100%',
        })
  
        property = '50% 100%';
        scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;
  
        ele.classList.add(cls + index);
        gsap.to('.' + cls + index, {
          objectPosition: property,
          scrollTrigger: {
            trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
            start: 'top bottom',
            end: 'bottom top',
            scrub: scrub,
            merker: true,
          }
        })
      })
    }
  }
  
    class InviewEvent {
    constructor(el, opt){
      this.el = "." + el;
      this.all = this.el + '-all';
      this.eachUp = this.el + '-each';
      this.eachItem = this.el + '-eachItem';
      this.eachItemFast = this.el + '-eachItem-fast';
      this.eachItemDelay = this.el + '-eachItem-delay';
      /** stagger-n：opacity のみ・1→2→3…と遅延（MV / MESSAGE 背景など） */
      this.eachStaggerNClass = 'js-inview-each-stagger-n';
      if($(this.el).length > 0){
        this.event();
      }
    }
    event() {
      let options = {
        threshold: [0, 0.05, 0.1, 1]
      }
      let optionsAll = {
        threshold: [0, 0.9, 1]
      }
      const observerEnter = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio >= 0.05){
            item.classList.add('is-inview');
            if(item.classList.contains('js-inview-each')){
              this.inviewEachUp(item);
            }
            if(item.classList.contains('js-inview-lottie')){
              this.inviewLottie(item);
            }
            observerEnter.unobserve(item);
          }
        });
      }, options);
      const observerAll = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio >= 0.9){
            item.classList.add('is-inview');
            if(item.classList.contains('js-inview-each')){
              this.inviewEachUp(item);
            }
            observerAll.unobserve(item);
          } else {
            item.classList.remove('is-inview');
          }
        });
      }, optionsAll);
      const inviewItem = document.querySelectorAll(this.el);
      const inviewAllItem = document.querySelectorAll(this.all);
      inviewItem.forEach((e)=>{
        observerEnter.observe(e);
      });
      inviewAllItem.forEach((e)=>{
        observerAll.observe(e);
      });
    }
    inviewEachUp(item){
      $(item).find(this.eachItem).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.2 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
      $(item).find(this.eachItemFast).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.1 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
      $(item).find(this.eachItemDelay).each((i,el)=>{
        const delayStep = item.classList.contains(this.eachStaggerNClass) ? 0.85 : 0.5;
        gsap.to($(el), {
          delay: (delayStep * i),
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
    }
    inviewLottie(item){
      if($(item).hasClass('js-lottie-flow')) {
        lottie.flow();
      }
      if($(item).hasClass('js-lottie-no01')) {
        lottie.no01();
      }
      if($(item).hasClass('js-lottie-no02')) {
        lottie.no02();
      }
      if($(item).hasClass('js-lottie-no03')) {
        lottie.no03();
      }
      if($(item).hasClass('js-lottie-no04')) {
        lottie.no04();
      }
      if($(item).hasClass('js-lottie-no05')) {
        lottie.no05();
      }
      if($(item).hasClass('js-lottie-no06')) {
        lottie.no06();
      }
      if($(item).hasClass('js-lottie-no07')) {
        lottie.no07();
      }
    }
  }
  
    class Modal {
    constructor(el,opt){
      this.el = el;
      this.event();
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $("." + this.el).on('click', function(e) {
        e.preventDefault();
        $(`[data-id='${$(this).attr('id')}']`).addClass('is-active');
        scrollBanOpen();
      })
  
      $("." + this.el + "-close").on('click', function() {
        $('.js-modal-container').removeClass('is-active');
        scrollBanClase();
      })
    }
  }
    // -------------------------------------------------
  // スクロール禁止
  // -------------------------------------------------
  let scrollTop = 0;
  
  function scrollBan() {
    const body = $('html')[0];
    // スクロール禁止
    if(body.classList.contains('is-hidden')){
      body.classList.remove('is-hidden');
      window.scrollTo(0, scrollTop);
      $('html').css({'scroll-behavior': 'smooth'})
    } else {
      scrollTop = window.scrollY;
      body.style.top = (scrollTop * -1) + 'px';
      body.classList.add('is-hidden');
      $('html').css({'scroll-behavior': 'inherit'})
    }
  }
    // -------------------------------------------------
  // スクロール検知：body に .is-scroll、ヘッダーに .scroll-active を付与
  // トップ（.p-top）のみ：.s-about セクションを通過するまで付与しない
  // -------------------------------------------------
  class ScrollObserve {
    constructor() {
      this.body = document.body;
      this.header = document.querySelector('.js-header');
      this.scrollThreshold = 1; // 1px以上スクロールで付与（トップ以外）
      this.init();
    }
  
    init() {
      this.checkScroll();
      window.addEventListener('scroll', () => this.checkScroll(), { passive: true });
      window.addEventListener('resize', () => this.checkScroll(), { passive: true });
      // 初回表示時・リサイズ時にもチェック
      window.addEventListener('load', () => this.checkScroll());
    }
  
    getScrollTop() {
      return window.scrollY ?? document.documentElement.scrollTop ?? 0;
    }
  
    /**
     * トップページ：ビューポート上端が .s-about の下端を過ぎたら true
     */
    isPastAboutSection() {
      const about = document.querySelector('.p-top .s-about');
      if (!about) return this.getScrollTop() >= this.scrollThreshold;
      return about.getBoundingClientRect().bottom <= 0;
    }
  
    checkScroll() {
      const isTop =
        this.header && this.header.classList.contains('p-top');
      const isScrolled = isTop
        ? this.isPastAboutSection()
        : true;
      if (isScrolled) {
        this.body.classList.add('is-scroll');
        if (this.header) this.header.classList.add('scroll-active');
      } else {
        this.body.classList.remove('is-scroll');
        if (this.header) this.header.classList.remove('scroll-active');
      }
    }
  }
  
    class TopElementor {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $('.js-elementor-drawer-trigger').on('click', function(){
        $('html').toggleClass('is-elementor-drawer-open');
        scrollBan();
      });
  
      let scrollTimer;
      $(window).on('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          if($(window).scrollTop() > 100) {
            $('html').addClass('is-scroll');
          } else {
            $('html').removeClass('is-scroll');
          }
        }, 100);
      });
  
    }
  }
  

  // ページ読み込みが完了したら100%に設定し、しばらく後にバーを消す
  window.addEventListener('load', () => {
    setTimeout(() => {
      $('.js-loading').fadeOut();
    }, 1500);
  });

  (() => {

    let imgParallax = new ImgParallax('js-parallax');
    let inviewEvent = new InviewEvent('js-inview');
    let scrollObserve = new ScrollObserve();
    
    // ------------------------------
    // トップページ用
    // ------------------------------
    let top = new Top('p-top');
    
    // ------------------------------
    // ページビルダー用
    // ------------------------------
    let topElementor = new TopElementor('js-topElementor');
    let modal = new Modal('js-modal');
    let accordion = new Accordion('js-accordion');
    let editor = new Editor('c-content');

  })();

  //DOMContentLoaded
  $(() => {
  });

  //images resources loaded
  $(window).on('load', () => {

    $(window).trigger('loading');
  });

  //after loading animation
  $(window).on('loading', () => {
  });
})(jQuery);